/**
 * AWS WAF CAPTCHA integration for the contact form. (BL-0096)
 *
 * Both values below are PUBLIC by design. AWS's own documented integration
 * embeds the API key in client-side JavaScript: it identifies which web ACL to
 * ask for a puzzle and is scoped to the three hostnames listed on the key, so
 * it authorises nothing on its own. Treating it as a secret would mean it
 * could not do its job.
 *
 * The key is REGIONAL / us-east-2, version 1, created 2026-08-29 in account
 * 891377177867 (DoxProdPRC), with TokenDomains exactly:
 *   archives.standards.doxcelerate.com
 *   archives.directives.doxcelerate.com
 *   archives.nnsa.doxcelerate.com
 *
 * Rotating it means creating a new key with the same domains and replacing the
 * string here; keys do not expire on their own.
 */

/** The per-web-ACL SDK. Loaded only on /contact -- it is the only page that
 *  submits, and there is no reason to hand every visitor a third-party
 *  request they will never use. */
export const WAF_CAPTCHA_SCRIPT =
  'https://d68bf3d1aac4.us-east-2.captcha-sdk.awswaf.com/d68bf3d1aac4/jsapi.js';

export const WAF_CAPTCHA_API_KEY =
  'X+ulNuKVY2Us5RZklflz+/gzuUQN62TZoCPiekI4dt2bSLB0evlBmWpZytICSwkvzUFik0xKkbgzMvYRG51pchnNuiz8rPQmS+l0bjnh/iPSQZe0I/7rJfTUzINNDnqx1nwcHHrX8zf1+80SSlXqnGsFR72TDsDKOgxyUkIjMV6wSoLd90WeGzwUVPye5tGilgxOizb1pM5R/J4Hg1//TZ1aIG9QDLx44k3Tbyms71JCVbwkuvNNocDNCfFL+iYWEGGsq6o3ZDcFSIzETkQazPlcYSVl6XMa6EREJ+yA4TWa7CsGoOVOyWa1Sm5CmtZVDEqCL8NbiHkcZYsjeCw8dkvI0eJ9GwIcjdYpUPk+Kjyza7pZ8KS0uWX0i9ZeiBm6ORFMDPnRzVc5sZQkbYLHUYufjk58+F6ZfZrDg9uB8HrjBo+RYjQn8plEu1xJtxqDRe0HGWETZU1kDeCCMV861vsOQNr8R/Jm7neWRuIeQ34YMcdvumY68wu58kX1ldp6CknKeJSpto1YSsJb1Tr5G6ug7zlrWyxaEUXLFhQByJh2Bosf1im+8J6whBHRb5kpgJhkN5sYhcU2FpSNxuc9LSHfhQQMESeuQUD2+0/h5lR5nmOIP3MlQQ4eyML02ydUB8tNX7pBn5aeK8ogjbEhikqP9caBvs1T+C03NaR+tQ0=_0_1';

/** Where the form posts. Same origin, so the WAF sees it on the archive's own
 *  hostname and the 405 that means "solve a puzzle" is readable to us -- a
 *  cross-origin call could not read it, because that response carries no CORS
 *  headers. */
export const CONTACT_ENDPOINT = '/++api++/@contact';

/** The address the page falls back to when JavaScript is off, when the SDK
 *  cannot load, or when a submission fails outright. The ONLY address any of
 *  these archives publishes. */
export const CONTACT_EMAIL = 'doe.archives@doxcelerate.com';
